'use client';

import { Session } from 'next-auth';
import { SessionProvider as AuthSessionProvider } from 'next-auth/react';

type Props = {
  children?: React.ReactNode;
  session: Session | null;
};

export const SessionProvider = ({ children, session }: Props) => {
  return (
    <AuthSessionProvider session={session} refetchInterval={30}>
      {children}
    </AuthSessionProvider>
  );
};
